import { render, staticRenderFns } from "./IconDeposit.vue?vue&type=template&id=da643da8"
import script from "./IconDeposit.vue?vue&type=script&lang=ts"
export * from "./IconDeposit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports